{
  "CUSTOM_ROLE": {
    "HEADER": "사용자 지정 역할",
    "LEARN_MORE": "사용자 지정 역할에 대해 더 알아보기",
    "DESCRIPTION": "사용자 지정 역할은 계정 소유자 또는 관리자가 만든 역할입니다. 이 역할은 에이전트에게 할당하여 계정 내 접근 권한 및 권한을 정의할 수 있습니다. 사용자 지정 역할은 조직의 요구 사항에 맞는 특정 권한 및 접근 수준으로 생성할 수 있습니다.",
    "COUNT": "{n}개의 사용자 지정 역할 | {n}개의 사용자 지정 역할",
    "HEADER_BTN_TXT": "사용자 지정 역할 추가",
    "LOADING": "사용자 지정 역할을 불러오는 중...",
    "SEARCH_PLACEHOLDER": "사용자 지정 역할 검색...",
    "NO_RESULTS": "검색과 일치하는 사용자 지정 역할이 없습니다",
    "SEARCH_404": "이 쿼리와 일치하는 항목이 없습니다.",
    "PAYWALL": {
      "TITLE": "사용자 지정 역할을 만들려면 업그레이드하십시오",
      "AVAILABLE_ON": "사용자 지정 역할 기능은 Business 및 Enterprise 플랜에서만 사용할 수 있습니다.",
      "UPGRADE_PROMPT": "팀 관리, 자동화, 사용자 지정 속성 등 고급 기능에 접근하려면 플랜을 업그레이드하십시오.",
      "UPGRADE_NOW": "지금 업그레이드",
      "CANCEL_ANYTIME": "언제든지 플랜을 변경하거나 취소할 수 있습니다"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "사용자 지정 역할 기능은 유료 플랜에서만 사용할 수 있습니다.",
      "UPGRADE_PROMPT": "감사 로그, 에이전트 용량 등 고급 기능에 접근하려면 유료 플랜으로 업그레이드하십시오.",
      "ASK_ADMIN": "업그레이드에 대해 관리자에게 문의하십시오."
    },
    "LIST": {
      "404": "이 계정에서 사용 가능한 사용자 지정 역할이 없습니다.",
      "TITLE": "사용자 지정 역할 관리",
      "DESC": "사용자 지정 역할은 계정 소유자 또는 관리자가 만든 역할입니다. 이 역할은 에이전트에게 할당하여 계정 내 접근 권한 및 권한을 정의할 수 있습니다. 사용자 지정 역할은 조직의 요구 사항에 맞는 특정 권한 및 접근 수준으로 생성할 수 있습니다.",
      "TABLE_HEADER": {
        "NAME": "이름",
        "DESCRIPTION": "설명",
        "PERMISSIONS": "권한",
        "ACTIONS": "액션"
      }
    },
    "PERMISSIONS": {
      "CONVERSATION_MANAGE": "모든 대화 관리",
      "CONVERSATION_UNASSIGNED_MANAGE": "배정되지 않은 대화 및 자신에게 배정된 대화 관리",
      "CONVERSATION_PARTICIPATING_MANAGE": "참여 중인 대화 및 자신에게 배정된 대화 관리",
      "CONTACT_MANAGE": "연락처 관리",
      "REPORT_MANAGE": "보고서 관리",
      "KNOWLEDGE_BASE_MANAGE": "지식 기반 관리"
    },
    "FORM": {
      "NAME": {
        "LABEL": "이름",
        "PLACEHOLDER": "이름을 입력하십시오.",
        "ERROR": "이름이 필요합니다."
      },
      "DESCRIPTION": {
        "LABEL": "설명",
        "PLACEHOLDER": "설명을 입력하십시오.",
        "ERROR": "설명이 필요합니다."
      },
      "PERMISSIONS": {
        "LABEL": "권한",
        "ERROR": "권한이 필요합니다."
      },
      "CANCEL_BUTTON_TEXT": "취소",
      "API": {
        "ERROR_MESSAGE": "Woot 서버에 연결할 수 없습니다. 나중에 다시 시도해 주십시오."
      }
    },
    "ADD": {
      "TITLE": "사용자 지정 역할 추가",
      "DESC": "사용자 지정 역할을 사용하면 조직의 요구 사항에 맞는 특정 권한 및 접근 수준으로 역할을 생성할 수 있습니다.",
      "SUBMIT": "제출",
      "API": {
        "SUCCESS_MESSAGE": "사용자 지정 역할이 성공적으로 추가되었습니다."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "수정",
      "TITLE": "사용자 지정 역할 편집",
      "DESC": "사용자 지정 역할을 사용하면 조직의 요구 사항에 맞는 특정 권한 및 접근 수준으로 역할을 생성할 수 있습니다.",
      "SUBMIT": "업데이트",
      "API": {
        "SUCCESS_MESSAGE": "사용자 지정 역할이 성공적으로 업데이트되었습니다."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "삭제",
      "API": {
        "SUCCESS_MESSAGE": "사용자 지정 역할이 성공적으로 삭제되었습니다.",
        "ERROR_MESSAGE": "Woot 서버에 연결할 수 없습니다. 나중에 다시 시도해 주십시오."
      },
      "CONFIRM": {
        "TITLE": "삭제 확인",
        "MESSAGE": "삭제하시겠습니까? ",
        "YES": "예, 삭제합니다 ",
        "NO": "아니요, 유지합니다 "
      }
    }
  }
}
